import axiosInstance from "@/api/axios";

export const getPlatforms = async ({ status = "", name = "" }) => {
  try {
    const response = await axiosInstance.get(`/platforms/?status=${status}&name=${name}`);

    return response;
  } catch (error) {
    console.error("getPlatforms :>> ", error);
    return error;
  }
};

export const getPlatformsAccounts = async ({ isActive = "", _id = "", platformId = "" }) => {
  try {
    const response = await axiosInstance.get(`/platformsAccounts/?isActive=${isActive}&userId=${_id}&platformId=${platformId}`);

    return response;
  } catch (error) {
    console.error("getPlatformsAccounts :>> ", error);
    return error;
  }
};

export const putPlatformAccount = async (_id, body) => {
  try {
    const response = await axiosInstance.put(`/platformsAccounts/findAndUpdate/${_id}`, body);

    return response;
  } catch (error) {
    console.error("putPlatformAccount :>> ", error);
    return error;
  }
};

export const createPlatformAccount = async (body) => {
  try {
    const { data } = await axiosInstance.post(`/platformsAccounts`, body);

    return data;
  } catch (error) {
    console.error("createPlatformAccount :>> ", error);
    return error;
  }
};
